import React from "react";

const CoAuthLayout = ({ children }) => {
  return (
    <div>
      <div className="login container">
        <div className="row h-100">
          {/* LEFT LOGIN IMAGE */}
          <div className="col-md-6 m-auto position-relative p-0 respocollog">
            <div className="Cologinbackground">
              <div className="login_details">
                <h2 className="Small-Heading fw-600 text-white text-center">
                  Teachers thrive when students Learn & Achieve
                </h2>
              </div>
            </div>
          </div>
          {/* RIGHT SIDE */}
          <div className="col-md-6 m-auto ">
            {/* Auth BOX */}
            <div className="login_img" id="btn1">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default CoAuthLayout;
